import {Component, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {of} from 'rxjs';
import {catchError, switchMap} from 'rxjs/operators';
import {AnalyticsService} from '../../shared/analytics.service';
import {ApiService, HttpError} from '../../shared/api.service';
import {AppStateService} from '../../shared/app-state.service';
import {AuthService} from '../../shared/auth.service';
import {NavigationService} from '../../shared/navigation.service';
import {StorageService} from '../../shared/storage.service';

@Component({
  selector: 'login-as-page',
  template: ''
})
export class LoginAsPageComponent implements OnInit {

  submitError: string | null = null;
  submitErrorCode: string | null = null;

  constructor(private AppState: AppStateService,
              private Storage: StorageService,
              private Analytics: AnalyticsService,
              private Api: ApiService,
              private Auth: AuthService,
              private Navigation: NavigationService,
              private route: ActivatedRoute) {
  }

  ngOnInit() {
    this.Api.authenticateAs(this.route.snapshot.queryParams.authToken)
      .pipe(
        catchError((err: HttpError) => {
          if ((err.status === 400 && err.code === 'invalid_grant')
            || (err.status === 401 && err.code === 'unauthorized')) {
            const credentialsError = () => {
              this.submitError = 'incorrect-credentials';
              this.Analytics.trackEvent('LoginAs incorrect credentials', {category: 'Action'});
              this.Navigation.handleError(err);
            };
            credentialsError();
          } else {
            this.submitError = 'server-error';
            this.submitErrorCode = err.code;
            this.Analytics.trackEvent('LoginAs failed', {category: 'Error', code: err.code});
            this.Navigation.handleError(err);
          }
          return of(null);
        }),
        switchMap(() => this.Api.refreshUser())
      )
      .subscribe(() => {
        if (this.Auth.isFullyAuthenticated()) {
          this.Analytics.trackEvent('LoginAs succeeded');
          this.Navigation.handleLogin(true);
        }
      }, err => {
        this.Analytics.trackEvent('LoginAs failed while refreshing user', {category: 'Error', code: err.code});
        this.submitError = err === 'unauthorized' ? 'unauthorized' : 'incorrect-credentials';
        this.Navigation.handleError(err);
      });
  }
}
